"use client";
import { useState, useEffect, useRef, Fragment, useMemo } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import IconArrow from "assets/svg/chevron-down.svg";

import { getSuggestion, getSuggestionForAgent, getSuggestionForProject } from "services/suggestion";
import { debounce } from "@/src/components/listing-map/map/helpers";

import styles from "./styles.module.css";

const SuggestionBox = ({ freeText, categoryId, tradeTypeId, handlePOIClick, agent, suggestionClass, isProject }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState();
  const [moreOfficeResult, setMoreOfficeResult] = useState(false);

  const divRef = useRef(null);

  const wrapperClass = classNames({
    [styles.wrapper]: true,
    [suggestionClass]: suggestionClass,
  });

  const listWrapperClass = classNames({
    [styles.listWrapper]: true,
    [styles.estateOfficeListHeight]: agent,
    [styles.estateOfficeOverflow]: agent && moreOfficeResult,
  });

  const getDataForSuggestion = async (freeText, categoryId, tradeTypeId) => {
    let suggestionData;

    try {
      if (agent) {
        suggestionData = await getSuggestionForAgent(freeText);
      } else if (isProject) {
        suggestionData = await getSuggestionForProject(freeText);
      } else {
        suggestionData = await getSuggestion(freeText, categoryId, tradeTypeId, "");
      }
    } catch (error) {
      suggestionData = null;
    }

    setData(suggestionData?.result);
    setIsOpen(true);
  };

  const debouncedFetch = useMemo(
    () =>
      debounce((text, catId, tradeType) => {
        getDataForSuggestion(text, catId, tradeType);
      }, 500),
    []
  );

  useEffect(() => {
    if (freeText.length >= 3) {
      debouncedFetch(freeText, categoryId, tradeTypeId);
    } else {
      setIsOpen(false);
    }
  }, [freeText, categoryId, tradeTypeId, debouncedFetch]);

  const handleClickOutside = (event) => {
    if (divRef.current && !divRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [divRef]);

  const handleClick = (item, key) => {
    setIsOpen(false);
    handlePOIClick && handlePOIClick(item, key);
  };

  return (
    <>
      {isOpen && (
        <div ref={divRef} className={wrapperClass}>
          {data?.suggestions?.map((item, index) => (
            <Fragment key={index}>
              {item?.records?.length > 0 && (
                <>
                  <div className={styles.titleWrapper}>
                    <span className={styles.title}>{item?.name}</span>
                  </div>
                  <div className={styles.boxWrapper} key={index}>
                    <ul className={listWrapperClass}>
                      {item?.records?.map((child, chilIndex) => (
                        <li key={chilIndex} className={styles.list} onClick={() => handleClick(child, item?.key)}>
                          {child?.name}
                        </li>
                      ))}
                    </ul>
                    {agent && !moreOfficeResult && (
                      <button onClick={() => setMoreOfficeResult(true)} className={styles.moreResult}>
                        Diğer Sonuçları Gör{" "}
                        <span className={styles.icon}>
                          <IconArrow />
                        </span>
                      </button>
                    )}
                  </div>
                </>
              )}
            </Fragment>
          ))}
        </div>
      )}
    </>
  );
};

SuggestionBox.propTypes = {
  freeText: PropTypes.string,
  categoryId: PropTypes.number,
  tradeTypeId: PropTypes.number,
  handlePOIClick: PropTypes.func,
  agent: PropTypes.bool,
  suggestionClass: PropTypes.string,
  isProject: PropTypes.bool,
};

export default SuggestionBox;
